import urls from '../secrets-web/src/config/urls';

export default {
  ...urls,
  LANDING_URL: process.env.REACT_APP_LANDING_URL,
  LOCKER_ID_URL: process.env.REACT_APP_LOCKER_ID_URL,
  MASTER_PASSWORD: 'https://locker.io/passwords/master-password',
  SUPPORT_URL: 'https://support.locker.io',
  FORUM_URL: 'https://github.com/orgs/lockerpm/discussions',
  TERMS_URL: 'https://locker.io/passwords/terms',
  DOC_LINKS: {
    ...urls.DOC_LINKS,
    vi: {
      ...urls.DOC_LINKS.vi,
      WS_SETTINGS_MEMBERS: 'https://support.locker.io/vi/locker-secrets-manager/get-started/workspace-management/workspace-members/manage-workspace-members-on-cloud-secrets-manager',
      WHAT_IS_MASTER_PASSWORD: 'https://support.locker.io/vi/locker-general/login-unlock/log-in-to-a-cloud-account/what-is-master-password',
      TWO_FA_FOR_LOCKER_ACCOUNT: 'https://support.locker.io/vi/locker-general/security-for-locker-account/2fa-for-locker-account',
      SECURITY_UPGRADE_URL: 'https://locker.io/vi/blog/nang-cap-bao-mat-khoa-chinh-master-key'
    },
    en: {
      ...urls.DOC_LINKS.en,
      WS_SETTINGS_MEMBERS: 'https://support.locker.io/en/locker-secrets-manager/get-started/workspace-management/workspace-members/manage-workspace-members-on-cloud-secrets-manager',
      WHAT_IS_MASTER_PASSWORD: 'https://support.locker.io/en/locker-general/login-unlock/log-in-to-a-cloud-account/what-is-master-password',
      TWO_FA_FOR_LOCKER_ACCOUNT: 'https://support.locker.io/en/locker-general/security-for-locker-account/2fa-for-locker-account',
      SECURITY_UPGRADE_URL: 'https://locker.io/blog/master-key-security-upgrade'
    },
  }
};
